{
	"imprintTitle": "Colofon",
	"termsAndConditionsTitle": "Algemene voorwaarden",
	"privacyPolicyTitle": "Privacybeleid",
	"openSourceAttributionTitle": "Open source-vermelding"
}
